import { SlicePipe } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContentfulArticleContent } from 'src/app/core/interfaces/Contentful/Article/ContentfulArticleContent';
import { ContentfulArticleOverviewContent } from 'src/app/core/interfaces/Contentful/ArticleOverview/ContentfulArticleOverviewContent';

@Component({
  selector: 'app-contentful-articles-list',
  templateUrl: './contentful-articles-list.component.html',
  styleUrls: ['./contentful-articles-list.component.scss'],
  standalone: true,
  imports: [SlicePipe],
})
export class AppContentfulArticlesListComponent implements OnChanges {
  @Input() contentfulArticlesListContent: Array<ContentfulArticleContent> | undefined;
  contentfulArticlesOverviewListContent: Array<ContentfulArticleOverviewContent> = [];
  contentfulRelatedArticlesList$ = new BehaviorSubject<ContentfulArticleOverviewContent[]>([]);

  ngOnChanges(changes: SimpleChanges): void {
    const articlesListCurrentValue: Array<ContentfulArticleContent> = changes.contentfulArticlesListContent.currentValue;

    if (articlesListCurrentValue) {
      // Filter and format all the articles list and check if there's a valid slug property in each of them (needed for hyperlinks)
      const contentfulFilteredArticlesList = articlesListCurrentValue.filter(
        (articlesListContent) => articlesListContent && articlesListContent.overview,
      );

      contentfulFilteredArticlesList.map((articleList) => {
        // contentful-related-articles case
        if (articleList.relatedArticles) {
          articleList.relatedArticles.map((relatedArticle) => {
            if (relatedArticle.slug) {
              this.contentfulArticlesOverviewListContent.push(relatedArticle);
            }
          });
        } else if (articleList.overview?.slug) {
          // contentful-landing-page case
          this.contentfulArticlesOverviewListContent.push(articleList.overview);
        }
      });

      this.contentfulRelatedArticlesList$.next(this.contentfulArticlesOverviewListContent);
    }
  }
}
